/*
* Created by Tigran Yengibaryan
* Created on 11/06/2021 11:23
*
* Copyright (c) 2021 PicsArt.Inc
*/

import styled from 'styled-components';
import { useRecoilState } from 'recoil';
import { backgroundStep } from '../models';

const Content = styled.div``;

const Media = styled.div``;

const Heading = styled.h1`
  font-weight: bold;
  font-size: 3.5rem;
  line-height: 4.375rem;
`;

const Text = styled.p`
  font-size: 1.5rem;
  line-height: 2rem;
`;

const Button = styled.button`
  background: #C209C1;
  border-radius: 10px;
  text-transform: capitalize;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5rem;
  border: none;
  padding: 16px 17px;
`;

const Page = styled.div`
  padding-left: 45px;
  padding-right: 28px;
  display: flex;
  height: 100%;
  align-items: center;
`;

export const HomePage = () => {
  const [, setStep] = useRecoilState(backgroundStep);

  const handleTypeOpen = () => setStep('type');

  return (<Page>
    <Content>
      <Heading>Background Generating Has Never Been so Easy</Heading>
      <Text>Our Background Maker is insanely good — and it’s at your fingertips</Text>
      <Button onClick={handleTypeOpen}>Try Background Generate</Button>
    </Content>
    <Media>
    </Media>
  </Page>)
}
